/**
 * Sync-contract tussen de localStorage-funnels (HD-chartomgeving) en de
 * backend-sync van per-user data (`UserDataSyncService`). Bewust een neutraal
 * moduul zonder Angular- of human-design-afhankelijkheden zodat beide kanten
 * hierop kunnen leunen zonder kringimporten.
 *
 * - De funnels melden elke geslaagde localStorage-write via
 *   {@link notifyUserDataSavedLocally}.
 * - De sync-service registreert zich éénmalig via
 *   {@link setUserDataLocalSyncListener} (alleen bij een ingelogde gebruiker);
 *   zonder listener zijn de meldingen no-ops.
 */

export type UserDataSyncCategory = 'settings' | 'appState';

/**
 * localStorage-keys van de gesynchroniseerde blobs. Dit moduul is de bron van
 * waarheid; de HD-bestanden re-exporteren deze onder hun bestaande namen
 * (`HD_CHART_GLOBAL_SETTINGS_STORAGE_KEY`, `HD_CHART_TABS_STORAGE_KEY`).
 */
export const USER_DATA_SETTINGS_STORAGE_KEY = 'hdChartGlobalSettings';
export const USER_DATA_APP_STATE_STORAGE_KEY = 'hdChartTabs';

export const USER_DATA_CATEGORY_STORAGE_KEYS: Readonly<Record<UserDataSyncCategory, string>> = {
  settings: USER_DATA_SETTINGS_STORAGE_KEY,
  appState: USER_DATA_APP_STATE_STORAGE_KEY,
};

export type UserDataLocalSyncListener = (category: UserDataSyncCategory, json: string) => void;

let listener: UserDataLocalSyncListener | undefined;

/** Registreert (of wist, met `undefined`) de app-brede sync-listener. */
export function setUserDataLocalSyncListener(value: UserDataLocalSyncListener | undefined): void {
  listener = value;
}

/** Meldt dat een funnel zonet `json` onder de key van `category` heeft weggeschreven. */
export function notifyUserDataSavedLocally(category: UserDataSyncCategory, json: string): void {
  listener?.(category, json);
}
